import { render } from "./SolicitudVacaciones.vue?vue&type=template&id=5f49eba5"
import script from "./SolicitudVacaciones.vue?vue&type=script&lang=js"
export * from "./SolicitudVacaciones.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__